<div class="handler-message-demo-container">
  <!-- Header -->
  <div class="demo-header">
    <h1 class="demo-title">Handler Message Service</h1>
    <p class="demo-description">
      Sistema centralizado de manejo de mensajes
    </p>
  </div>

  <!-- Tabs principales -->
  <mat-tab-group class="demo-tabs" animationDuration="200ms">
    
    <!-- TAB 1: Casos Básicos -->
    <mat-tab label="Básicos">
      <div class="tab-content">
        <div class="cases-grid">
          <div *ngFor="let case of useCases" class="case-card">
            <div class="case-header">
              <mat-icon class="case-icon">{{case.icon}}</mat-icon>
              <div class="case-info">
                <h3>{{case.title}}</h3>
                <p>{{case.description}}</p>
              </div>
            </div>
            <div class="code-container">
              <pre class="code-block"><code>{{case.code}}</code></pre>
              <div class="action-buttons">
                <button mat-icon-button class="copy-btn" (click)="copyCode(case.code)" matTooltip="Copiar código">
                  <mat-icon>content_copy</mat-icon>
                </button>
                <button mat-mini-fab color="primary" class="execute-btn" (click)="case.action()" matTooltip="Ejecutar">
                  <mat-icon>play_arrow</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- TAB 2: Códigos HTTP -->
    <mat-tab label="HTTP">
      <div class="tab-content">
        <div class="cases-grid">
          <div *ngFor="let case of httpCases" class="case-card">
            <div class="case-header">
              <mat-icon class="case-icon error">{{case.icon}}</mat-icon>
              <div class="case-info">
                <h3>{{case.title}}</h3>
                <p>{{case.description}}</p>
              </div>
            </div>
            <div class="http-code">{{case.code}}</div>
            <div class="http-action-center">
              <button mat-mini-fab color="primary" class="execute-btn" (click)="case.action()" matTooltip="Ejecutar">
                <mat-icon>play_arrow</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- TAB 3: Operaciones CRUD -->
    <mat-tab label="CRUD">
      <div class="tab-content">
        <div class="cases-grid">
          <div *ngFor="let case of crudCases" class="case-card">
            <div class="case-header">
              <mat-icon class="case-icon">{{case.icon}}</mat-icon>
              <div class="case-info">
                <h3>{{case.title}}</h3>
                <p>{{case.description}}</p>
              </div>
            </div>
            <div class="code-container">
              <pre class="code-block"><code>{{case.code}}</code></pre>
              <div class="action-buttons">
                <button mat-icon-button class="copy-btn" (click)="copyCode(case.code)" matTooltip="Copiar código">
                  <mat-icon>content_copy</mat-icon>
                </button>
                <button mat-mini-fab color="primary" class="execute-btn" (click)="case.action()" matTooltip="Ejecutar">
                  <mat-icon>play_arrow</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- TAB 4: Casos Especiales -->
    <mat-tab label="Especiales">
      <div class="tab-content">
        <div class="cases-grid">
          <div *ngFor="let case of specialCases" class="case-card">
            <div class="case-header">
              <mat-icon class="case-icon">{{case.icon}}</mat-icon>
              <div class="case-info">
                <h3>{{case.title}}</h3>
                <p>{{case.description}}</p>
              </div>
            </div>
            <div class="code-container">
              <pre class="code-block"><code>{{case.code}}</code></pre>
              <div class="action-buttons">
                <button mat-icon-button class="copy-btn" (click)="copyCode(case.code)" matTooltip="Copiar código">
                  <mat-icon>content_copy</mat-icon>
                </button>
                <button mat-mini-fab color="primary" class="execute-btn" (click)="case.action()" matTooltip="Ejecutar">
                  <mat-icon>play_arrow</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- TAB 5: Posicionamiento -->
    <mat-tab label="Posicionamiento">
      <div class="tab-content">
        <div class="cases-grid">
          <div *ngFor="let case of positioningCases" class="case-card">
            <div class="case-header">
              <mat-icon class="case-icon">{{case.icon}}</mat-icon>
              <div class="case-info">
                <h3>{{case.title}}</h3>
                <p>{{case.description}}</p>
              </div>
            </div>
            <div class="code-container">
              <pre class="code-block"><code>{{case.code}}</code></pre>
              <div class="action-buttons">
                <button mat-icon-button class="copy-btn" (click)="copyCode(case.code)" matTooltip="Copiar código">
                  <mat-icon>content_copy</mat-icon>
                </button>
                <button mat-mini-fab color="primary" class="execute-btn" (click)="case.action()" matTooltip="Ejecutar">
                  <mat-icon>play_arrow</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- TAB 6: Mensajes Default -->
    <mat-tab label="Mensajes Default">
      <div class="tab-content">
        <div class="cases-grid">
          <div *ngFor="let case of defaultMessageCases" class="case-card">
            <div class="case-header">
              <mat-icon class="case-icon">{{case.icon}}</mat-icon>
              <div class="case-info">
                <h3>{{case.title}}</h3>
                <p>{{case.description}}</p>
              </div>
            </div>
            <div class="code-container">
              <pre class="code-block"><code>{{case.code}}</code></pre>
              <div class="action-buttons">
                <button mat-icon-button class="copy-btn" (click)="copyCode(case.code)" matTooltip="Copiar código">
                  <mat-icon>content_copy</mat-icon>
                </button>
                <button mat-mini-fab color="primary" class="execute-btn" (click)="case.action()" matTooltip="Ejecutar">
                  <mat-icon>play_arrow</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- TAB 7: Simulaciones -->
    <mat-tab label="Simulaciones">
      <div class="tab-content">
        <div class="simulations-grid">
          <div class="simulation-card">
            <div class="sim-header">
              <mat-icon>http</mat-icon>
              <h3>Solicitud HTTP</h3>
            </div>
            <p>Simula petición al servidor</p>
            <button mat-flat-button color="primary" (click)="simulateHttpRequest()">
              Ejecutar
            </button>
          </div>

          <div class="simulation-card">
            <div class="sim-header">
              <mat-icon>assignment</mat-icon>
              <h3>Formulario</h3>
            </div>
            <p>Validación de campos</p>
            <button mat-flat-button color="primary" (click)="simulateFormSubmit()">
              Ejecutar
            </button>
          </div>

          <div class="simulation-card">
            <div class="sim-header">
              <mat-icon>save</mat-icon>
              <h3>Guardar</h3>
            </div>
            <p>Operación de guardado</p>
            <button mat-flat-button color="primary" (click)="simulateSaveOperation()">
              Ejecutar
            </button>
          </div>

          <div class="simulation-card">
            <div class="sim-header">
              <mat-icon>delete</mat-icon>
              <h3>Eliminar</h3>
            </div>
            <p>Eliminación de registro</p>
            <button mat-flat-button color="primary" (click)="simulateDeleteOperation()">
              Ejecutar
            </button>
          </div>

          <div class="simulation-card full-width">
            <div class="sim-header">
              <mat-icon>list</mat-icon>
              <h3>Secuencia Multi-Paso</h3>
            </div>
            <p>Proceso completo con 4 pasos consecutivos</p>
            <button mat-flat-button color="primary" (click)="runSequenceDemo()">
              Ejecutar Secuencia
            </button>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- TAB 8: Generador Personalizado -->
    <mat-tab label="Personalizado">
      <div class="tab-content">
        <div class="generator-container">
          <div class="generator-form">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Mensaje</mat-label>
              <input matInput [(ngModel)]="customMessage">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Tipo</mat-label>
              <mat-select [(ngModel)]="customType">
                <mat-option value="error">Error</mat-option>
                <mat-option value="warning">Advertencia</mat-option>
                <mat-option value="success">Éxito</mat-option>
                <mat-option value="info">Información</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Status Code</mat-label>
              <input matInput type="number" [(ngModel)]="customStatusCode" placeholder="200, 404...">
            </mat-form-field>

            <div class="slider-field">
              <label>Duración: {{customDuration}}ms</label>
              <mat-slider min="1000" max="10000" step="500" [(ngModel)]="customDuration">
                <input matSliderThumb>
              </mat-slider>
              <small class="hint-text" [class.hint-warning]="customDuration < 5000">
                <mat-icon>info</mat-icon>
                <span *ngIf="customDuration < 5000">
                  Valores menores a 5000ms usan el default (5000ms) automáticamente
                </span>
                <span *ngIf="customDuration >= 5000">
                  Duración personalizada aplicada
                </span>
              </small>
            </div>

            <button mat-flat-button color="primary" class="generate-btn" (click)="showCustomMessage()">
              Generar Mensaje
            </button>
          </div>

          <div class="code-preview">
            <div class="preview-header">
              <h4>Código:</h4>
              <button mat-icon-button class="copy-btn-preview" 
                (click)="copyCode(getGeneratedCode())" 
                matTooltip="Copiar código">
                <mat-icon>content_copy</mat-icon>
              </button>
            </div>
<pre class="code-block"><code>this.handlerMessage.{{customType}}({{'{'}}<br>  message: '{{customMessage}}'<span *ngIf="customStatusCode">,<br>  statusCode: {{customStatusCode}}</span><span *ngIf="customDuration >= 5000">,<br>  duration: {{customDuration}}</span><br>{{'}'}});</code></pre>
          </div>
        </div>
      </div>
    </mat-tab>

  </mat-tab-group>
</div>

